import { MainContentLayout } from 'shared/ui/layout';

import { EditConnectorInstruction } from 'features/instruction/edit-connector-instruction/ui';

export function EditConnectorInstructionPage() {
  return <MainContentLayout element={<EditConnectorInstruction />} />;
}
